module.exports = __webpack_public_path__ + "media/theme/edit normal-ad582bfc.svg";